import { Printer } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTier } from '@/hooks/useAuth';
import { useTenantPrinters } from '@/features/printers/hooks';
import { getEffectivePrinterLimit } from '@maker-toolchest/shared';

export function PrinterLimitFooter() {
  const { tier } = useTier();
  const { data: printersData, isLoading } = useTenantPrinters({
    page: 1,
    limit: 100,
    sortBy: 'addedAt',
    sortOrder: 'desc'
  });

  const printers = printersData || [];
  const printerCount = printers.length;
  const printerLimit = tier ? getEffectivePrinterLimit(tier) : Infinity;
  const isUnlimited = printerLimit === Infinity;

  // Show placeholder during loading
  if (isLoading) {
    return (
      <div className="flex-shrink-0 border-t border-border bg-background-subtle px-4 py-3">
        <div className="flex items-center gap-2">
          <Printer className="h-4 w-4 text-foreground-muted animate-pulse" />
          <span className="text-sm text-foreground-muted">Loading printer info...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-shrink-0 border-t border-border bg-background-subtle px-4 py-3">
      <div className="flex items-center justify-between gap-4">
        {/* Left side: Printer count indicator */}
        <div className="flex items-center gap-2">
          <Printer className="h-4 w-4 text-foreground-muted" />
          <span className="text-sm font-medium text-foreground">
            {isUnlimited
              ? `${printerCount} ${printerCount === 1 ? 'printer' : 'printers'}`
              : `${printerCount} of ${printerLimit} ${printerLimit === 1 ? 'printer' : 'printers'}`}
          </span>
        </div>

        {/* Right side: Upgrade link (only show if not unlimited) */}
        {!isUnlimited && (
          <Link
            to="/settings/subscription"
            className="text-sm font-medium text-primary hover:text-primary-hover"
          >
            Add more printers
          </Link>
        )}
      </div>
    </div>
  );
}
